import { get } from 'lodash';
import { mapActions } from 'vuex';
import loaderMixin from '@/mixins/loader';
import accountVerifyMixin from '@/mixins/accountVerify';
import promoCodeMixin from '@/mixins/promoCode';
import depositWarningMixin from '@/mixins/depositWarningMixin';

export default {
  mixins: [
    accountVerifyMixin,
    loaderMixin,
    promoCodeMixin,
    depositWarningMixin,
  ],
  data() {
    return {
      disclaimer: '',
      buttonDisabled: false,
      url: null,
      error: null,
    };
  },
  mounted() {
    this.loaderAdd();
    this.getPayNearMe('')
      .then((data) => {
        this.loaderRemove();
        this.url = data.url;
        this.promoCodeDetail = data.promoCodeDetail || {};
        this.disclaimer = data.disclaimer;
      })
      .catch((error) => {
        this.loaderRemove();
        this.error = get(error, 'response.data.message', 'Your authorization to deposit by cash has been disabled.');
      });
  },
  methods: {
    ...mapActions('wallet', ['getPayNearMe']),
    onDeposit() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Cash Deposit',
      });
      this.buttonDisabled = true;
      window.location.href = this.url;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-cash/add-funds-cash.js